var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDubbelsngny01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 209.88,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Lager 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "svg_1",
    fill: "#fff",
    points: "-7.52 225.93 251.95 225.93 251.95 0 -7.52 0 -7.52 225.93",
    className: "cls-1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    id: "svg_2",
    clipPath: "url(#clip-path)",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "svg_3",
    strokeWidth: "3px",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    stroke: "#000",
    fill: "#fff",
    points: "23,19.290000915527344 221.42001342773438,19.290000915527344 221.42001342773438,189.38999938964844 23,189.38999938964844 23,19.290000915527344 ",
    className: "cls-3"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "svg_4",
    strokeWidth: "3px",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    stroke: "#000",
    fill: "#fff",
    points: "104.72000122070312,19.290000915527344 81.80000305175781,31.229999542236328 58.67000198364258,63.810001373291016 56.060001373291016,73.44000244140625 62.42000198364258,65.97000122070312 100.66999816894531,59.72999954223633 93.3499984741211,31.260000228881836 104.9000015258789,19.290000915527344 ",
    className: "cls-3"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "svg_5",
    strokeWidth: "3px",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    stroke: "#000",
    fill: "#fff",
    points: "104.72000122070312,189.38999938964844 81.88999938964844,177.57000732421875 58.67000198364258,144.83999633789062 56.060001373291016,135.24000549316406 62.42000198364258,142.67999267578125 100.66999816894531,148.9499969482422 93.3499984741211,177.4199981689453 104.9000015258789,189.38999938964844 ",
    className: "cls-3"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "svg_6",
    strokeWidth: "3px",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    stroke: "#000",
    fill: "#fff",
    points: "56.060001373291016,73.44000244140625 56.060001373291016,135.24000549316406 62.42000198364258,142.67999267578125 74.95999908447266,144.75 74.95999908447266,63.93000030517578 62.42000198364258,65.97000122070312 56.060001373291016,73.44000244140625 ",
    className: "cls-3"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "svg_7",
    strokeWidth: "3px",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    stroke: "#000",
    fill: "#fff",
    points: "64.97000122070312,34.290000915527344 49.52000045776367,32.970001220703125 31.46000099182129,34.650001525878906 31.760000228881836,88.9800033569336 40.67000198364258,90.56999969482422 47.09000015258789,90.98999786376953 56.060001373291016,90.56999969482422 56.060001373291016,73.44000244140625 58.67000198364258,63.810001373291016 66.16999816894531,53.25 64.97000122070312,34.290000915527344 ",
    className: "cls-3"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "svg_8",
    strokeWidth: "3px",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    stroke: "#000",
    fill: "#fff",
    points: "56.060001373291016,118.11000061035156 40.63999938964844,118.11000061035156 31.760000228881836,119.69999694824219 31.46000099182129,174.02999877929688 42.470001220703125,175.47000122070312 56,175.47000122070312 64.97000122070312,174.38999938964844 66.16999816894531,155.42999267578125 58.67000198364258,144.83999633789062 56.060001373291016,135.24000549316406 56.060001373291016,118.11000061035156 ",
    className: "cls-3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDubbelsngny01);
export default __webpack_public_path__ + "static/media/dubbelsäng ny-01.688fe9bb9d1af287add243ee0107af75.svg";
export { ForwardRef as ReactComponent };